import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AdditionalFuelAllocationContainer from '../../containers/inventory/AdditionalFuelAllocation';
import FuelContractContainer from '../../containers/inventory/FuelContract';
import FMPRegionHeader from '../../components/ui/FMPRegionHeader';

import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

import FMPText from '../../components/pureForm/FMPText';
import FormComponent from '../../components/FormComponent';
import Button from '@material-ui/core/Button';
import FMPDatePicker from '../../components/pureForm/FMPDatePicker';
import FMPSectionHeader from '../../components/ui/FMPSectionHeader';
import FMPTerminalSupplierPicker from '../../components/pureForm/FMPTerminalSupplierPicker';
import FMPProductSelect from '../../components/pureForm/FMPProductSelect';

import { allProducts } from '../../libs/products';
import documentIcon from '../../images/document.svg';
import FMPAllocationReasonPicker from '../../components/pureForm/FMPAllocationReasonPicker';
import FMPFuelContractPicker from '../../components/pureForm/FMPFuelContractPicker';

const styles = (theme) => {
	return {
		sectionHeader: {
			margin: '30px 0px 10px 0px',
			textAlign: 'left',
			textTransform: 'uppercase',
			fontSize: 14,
			color: '#777',
			fontWeight: 900,
			letterSpacing: 2,
		},
		paper: {
			width: '100%',
			overflowX: 'auto',
			textAlign: 'left',
			boxSizing: 'border-box',
			padding: 20,
			[theme.breakpoints.up('md')]: {
				padding: '10px 40px 40px 40px',
			},
		},
		addInputButton: {
			borderRadius: '100px',
			marginTop: 20,
		},
		submitButton: {
			fontSize: 18,
			borderRadius: '100px',
			padding: '20px 30px',
			textTransform: 'uppercase',
		},
		formControl: {
			width: '100%',
			margin: '10px 0',
		},
		inputGroup: {
			borderLeft: '5px solid #ccc',
			marginTop: 10,
			marginBottom: 20,
		},
		infoBox: {
			fontSize: 14,
			alignItems: 'center',
			display: 'flex',
			backgroundColor: '#f7f7f7',
			padding: '10px 15px 15px 15px',
			marginTop: 10,
			marginBottom: 5,
		},
		infoIcon: {
			color: '#2196F3',
			width: 32,
			height: 32,
			paddingRight: 5,
			verticalAlign: 'middle',
		},
		documentIcon: {
			marginRight: 12,
			display: 'inline-block',
			width: 34,
			height: 40,
			backgroundImage: `url('${documentIcon}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			position: 'relative',
			flexShrink: 0,
			cursor: 'pointer',
		},
		note: {
			backgroundColor: '#D8F0FF',
			padding: 20,
			fontSize: 16,
			lineHeight: 1.4,
			marginBottom: 10,
			marginTop: 10,
			border: '1px solid #BADEFB',
		},
	};
};

class SaveAdditionalFuelAllocation extends FormComponent {
	constructor(props) {
		super(props);
		const additionalFuelAllocationId = _.get(this.props, [
			'match',
			'params',
			'additionalFuelAllocationId',
		]);
		const fuelContractId = _.get(this.props, ['match', 'params', 'fuelContractId']);

		this.state = {
			additionalFuelAllocationId: additionalFuelAllocationId
				? parseInt(additionalFuelAllocationId, 10)
				: undefined,
			isUpdate: additionalFuelAllocationId,
			fuelContractId: fuelContractId ? parseInt(fuelContractId, 10) : undefined,
			allocationReason: fuelContractId ? 'previousMonthRollOver' : '',
			formFieldError: {},
			resourceIds: [],
			finalCalculatedCosts: [],
			allocationDate: moment().format('YYYY-MM-DD'),
		};
		if (this.state.fuelContractId) {
			this.updateFormWithFuelContractInfo({ fuelContractId: this.state.fuelContractId });
		}
	}

	componentDidMount() {
		const { additionalFuelAllocation, getAdditionalFuelAllocation } = this.props;
		const { isUpdate, additionalFuelAllocationId } = this.state;

		if (!isUpdate) {
			return;
		}
		if (!additionalFuelAllocation) {
			getAdditionalFuelAllocation({
				params: { additionalFuelAllocationIds: [additionalFuelAllocationId] },
			});
		} else {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		const { fuelContractId } = this.state;

		//- When you change the contract info fill int he other items
		if (prevState.fuelContractId !== fuelContractId) {
			if (this.state.terminalSupplier) {
				return;
			}
			this.updateFormWithFuelContractInfo({ fuelContractId });
		}

		if (
			_.isUndefined(prevProps.additionalFuelAllocation) &&
			!_.isUndefined(this.props.additionalFuelAllocation)
		) {
			const newState = this.fillForm();
			this.setState(newState);
		}
	}

	updateFormWithFuelContractInfo({ fuelContractId }) {
		const { showErrors, getFuelContract } = this.props;

		getFuelContract({
			params: { fuelContractIds: [fuelContractId] },
			callback: (err, r) => {
				if (err) {
					return showErrors([err]);
				}
				if (!r) {
					return showErrors(['No result from getFuelContract']);
				}

				const fuelContract = _.get(r.collections, 'fuelContractCollection.0');
				if (!r) {
					return showErrors([`No fuel contract for`, fuelContractId]);
				}

				const { productType, allocatedForTerminalId, supplierForTerminalId } = fuelContract;
				const terminalSupplier = {
					terminalId: allocatedForTerminalId,
					supplierId: supplierForTerminalId,
				};

				this.setState({ productType, terminalSupplier });
			},
		});
	}

	fillForm = () => {
		const { additionalFuelAllocation } = this.props;
		if (!additionalFuelAllocation) {
			return;
		}

		const newState = {};
		[
			'productType',
			'numberOfGallons',
			'allocationDate',
			'fuelContractId',
			'allocationReason',
			'allocationReasonNote',
		].forEach((key) => {
			if (_.isNil(additionalFuelAllocation[key])) {
				return;
			}
			newState[key] = additionalFuelAllocation[key];
		});

		const { allocatedForTerminalId, supplierForTerminalId } = additionalFuelAllocation;
		newState.terminalSupplier = {
			terminalId: allocatedForTerminalId,
			supplierId: supplierForTerminalId,
		};

		return newState;
	};

	handleSave = () => {
		const { showErrors, addAdditionalFuelAllocation, updateAdditionalFuelAllocation } = this.props;
		const { isUpdate, additionalFuelAllocationId } = this.state;

		const formFieldError = {};
		_.values(this.requiredPathMap).forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});
		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const {
			productType,
			allocationDate,
			fuelContractId,
			allocationReason,
			allocationReasonNote,
			terminalSupplier,
		} = this.state;

		let numberOfGallons = this.state.numberOfGallons;
		if (numberOfGallons && _.isString(numberOfGallons)) {
			numberOfGallons = parseInt(numberOfGallons.replace(/,/g, ''), 10);
		}
		if (!_.isNumber(numberOfGallons)) {
			formFieldError.numberOfGallons = 'Number of gallons must be a number';
		}

		if (!_.isObject(terminalSupplier)) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		const allocatedForTerminalId = terminalSupplier.terminalId;
		const supplierForTerminalId = terminalSupplier.supplierId;

		if (!allocatedForTerminalId || !supplierForTerminalId) {
			formFieldError.terminalSupplier = 'Terminal / Supplier required';
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = {
			productType,
			allocationDate: moment(allocationDate).format('YYYY-MM-DD'),
			numberOfGallons: parseInt(numberOfGallons),
			fuelContractId: parseInt(fuelContractId),
			allocationReason,
			allocationReasonNote,
			allocatedForTerminalId,
			supplierForTerminalId,
		};

		if (!isUpdate) {
			addAdditionalFuelAllocation({ params });
		} else {
			params.additionalFuelAllocationId = additionalFuelAllocationId;
			updateAdditionalFuelAllocation({ params });
		}
	};

	render() {
		const { classes, additionalFuelAllocation } = this.props;
		const { isUpdate } = this.state;

		if (isUpdate && !additionalFuelAllocation) {
			return <div>Fetching additionalFuelAllocation details...</div>;
		}

		const action = isUpdate
			? 'Update Additional Fuel Allocation '
			: 'Add Additional Fuel Allocation';
		return (
			<Paper className={classes.paper}>
				<Grid container spacing={2}>
					<Grid item xs={12} sm={12} md={10} lg={8}>
						<Grid container spacing={2}>
							<Grid item xs={12} sm={12}>
								<FMPRegionHeader isTop={true} label={action} />
							</Grid>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Fuel Contract'} />
							</Grid>
							<FMPFuelContractPicker
								{...this.setForm(`fuelContractId`, 'Fuel Contract', true)}
								helpText={'Will auto fill from contract'}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Allocated At'} />
							</Grid>
							<FMPProductSelect
								{...this.setForm(`productType`, 'Product', true)}
								productTypes={_.map(allProducts, ({ value }) => {
									return value;
								})}
							/>
							<FMPTerminalSupplierPicker
								{...this.setForm(`terminalSupplier`, 'Terminal', true, {})}
								productTypes={[this.state.productType]}
							/>
							<FMPText {...this.setForm(`numberOfGallons`, 'Number of Gallons', true)} md={6} />
							<FMPDatePicker
								{...this.setForm(`allocationDate`, 'Allocate Date', true)}
								format={'M/D/YYYY'}
								md={6}
								helpText={'Date the fuel will be in tank for the above terminal / supplier'}
							/>

							<Grid item xs={12} sm={12}>
								<FMPSectionHeader label={'Fuel Source'} />
							</Grid>
							<FMPAllocationReasonPicker
								{...this.setForm(`allocationReason`, 'Allocation Reason', true)}
							/>
							<FMPText {...this.setForm(`allocationReasonNote`, 'Allocation Reason Note', false)} />

							<Grid item xs={12} sm={12} style={{ marginTop: 30 }}>
								<Button
									variant="contained"
									color="primary"
									className={classes.submitButton}
									onClick={this.handleSave}
								>
									{action}
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Paper>
		);
	}
}

SaveAdditionalFuelAllocation.propTypes = {
	classes: PropTypes.object.isRequired,
	addAdditionalFuelAllocation: PropTypes.func.isRequired,
	updateAdditionalFuelAllocation: PropTypes.func.isRequired,
	getAdditionalFuelAllocation: PropTypes.func.isRequired,
	getFuelContract: PropTypes.func.isRequired,

	additionalFuelAllocation: PropTypes.object,

	resourceMap: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	AdditionalFuelAllocationContainer,
	FuelContractContainer,
])(SaveAdditionalFuelAllocation);
